module.exports = __webpack_public_path__ + "img/user_rate.660eb6b4.svg";